import { render, staticRenderFns } from "./ScreenAxila.vue?vue&type=template&id=19b54f40&scoped=true&"
import script from "./ScreenAxila.vue?vue&type=script&lang=js&"
export * from "./ScreenAxila.vue?vue&type=script&lang=js&"
import style0 from "./ScreenAxila.vue?vue&type=style&index=0&id=19b54f40&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19b54f40",
  null
  
)

export default component.exports